module.exports = __webpack_public_path__ + "img/204.a79ce8ee.png";